import Axios from "./axios"; // 导入配置好的axios文件
import store from "@/store";
import VueCookies from 'vue-cookies'
import router from '@/router'
// import detailAxios from "./detailAxios"; // 导入配置好的axios文件
// 封装axios请求函数，并用export导出

const getBZhanData = {
  //内容类型
  getQueryInfo1() {
    return Axios({
      url: "bl-startag",
      method: "get",
    });
  },
  //UP主分区
  getQueryInfo2() {
    return Axios({
      url: "bl-partition",
      method: "get",
    });
  },
  //UP主所在地域
  getQueryInfo3() {
    return Axios({
      url: "bl-region",
      method: "get",
    });
  },
  //服务商
  getQueryInfo4() {
    return Axios({
      url: "bl-service",
      method: "get",
    });
  },
  getTableInfo(data){
    let query = ''
    for (let item in data) {
      if (item === 'content_tag_id'||item === 'fans_ranges'||item === 'task_price_ranges'){
        if(data[item]!==-1&&data[item]!=='-1'&&data[item]!==''){
          query = query + '&' + item + '=' + data[item]
        }
      }else if(item === 'min_fans_num'||item === 'max_fans_num'||item === 'min_task_price'||item === 'max_task_price'
        ||item === 'partition_id'||item === 'second_partition_id'||item === 'region_id'||item === 'second_region_id'
        ||item === 'gender'||item === 'male_attention_user_rates'||item === 'female_attention_user_rates'
        ||item === 'attention_user_ages'||item === 'attention_user_regionIds'||item === 'cooperation_types'||item === 'order_bys'
        ||item === 'key'){
        if(data[item]&& data[item]!==''){
          query = query + '&' + item + '=' + data[item]
        }
      }else if(item === 'hz'||item === 'tcount'||item === 'mcn'){
          if(data[item]){
            query = query + '&' + item + '=' + 1
          }
      }else if(item === 'devidedrate_ge'||item === 'provider_id'||item === 'page'||item==='spark_tag'){
        if(data[item]&&data[item]!=='0'&& data[item]!==''){
          query = query + '&' + item + '=' + data[item]
        }
      } else {
        if (data[item]) {
          query += '&' + item + '=' + data[item]
        }
      }
    }
    query = query.substring(1, query.length)
    console.log(query)
    return Axios({
      url: "bl-list?" + query,
      method: "get",
    });
  },
  // 获取UP主个人信息
  getBlPortrait(datas){
    return Axios({
      url: "bl-portrait" + datas,
      method: "get",
      showLoading: false,
    });
  },
  // 获取UP主最新作品
  getBlTrend(datas){
    return Axios({
      url: "bl-trend" + datas,
      method: "get",
      showLoading: false,
    });
  },
  // 获取UP主个人案例
  getRepresentative(datas){
    return Axios({
      url: "bl-representative" + datas,
      method: "get",
      showLoading: false,
    });
  },
  // 获取UP主关注用户趋势
  getBlAttention(datas){
    return Axios({
      url: "bl-attention" + datas,
      showLoading: false,
      method: "get",
    });
  },
  // 获取UP主粉丝重合
  getBlAttentionuser(datas){
    return Axios({
      url: "bl-attentionuser" + datas,
      showLoading: false,
      method: "get",
    });
  },
  // 获取UP主内容重合
  getBlSimilarcontent(datas){
    return Axios({
      url: "bl-similarcontent" + datas,
      showLoading: false,
      method: "get",
    });
  },
  // 获取稿件亮点
  getBlHighlights(params){
    return Axios({
      url: "bl-highlights",
      method: "get",
      showLoading: false,
      params
    });
  }
}

const getKuaishouData = {
  getQueryInfo1() {
    //内容分类
    return Axios({
      url: "ks-industrytag",
      method: "get",
    });
  },
  getQueryInfo2() {
    //所属行业
    return Axios({
      url: "ks-startag",
      method: "get",
    });
  },
  getQueryInfo3() {
    //筛选配置
    return Axios({
      url: "ks-webconf",
      method: "get",
      showLoading: false,
    });
  },
  getQueryInfo4() {
    //快手省份信息
    return Axios({
      url: "ks-address",
      method: "get",
    });
  },
  getTableInfo(data){
    let query = ''
    for (let item in data) {
      if (item === 'polarisIndustryTagIds' || item === 'polarisStarTagIds'){
        if(data[item]!==-1){
          query = query + '&' + item + '=' + data[item]
        }
      }else if(item === 'starMaxPrice'||item === 'starMinPrice'||item === 'fansMinNum'||item === 'fansMaxNum'||item === 'devidedrate_ge'){
        if(data[item]&&data[item]!=='0'&& data[item]!==''){
          query = query + '&' + item + '=' + data[item]
        }
      }else if(item === 'cityCode'||item === 'provinceCode'||item === 'gender'||
                item === 'fansAge'||item === 'fansArea'||item === 'fansGender'||
                item === 'fansMobile'||item === 'fansAgefrom'||item === 'fansAgeto'||
                item === 'fansAreafrom'||item === 'fansAreato'||item === 'fansGenderfrom'||
                item === 'fansGenderto'||item === 'fansMobilefrom'||item === 'fansMobileto'||
                item === 'expectCpmMinNum'||item === 'expectCpmMaxNum'||item === 'photoExpectPlayMinNum'||
                item === 'photoExpectPlayMaxNum'||item === 'starTagIds'||item === 'starOrderTag'||
                item === 'starOrderType'||item === 'page'||item === 'key'){
        if(data[item]!==''){
          query = query + '&' + item + '=' + data[item]
        }
      }else if(item === 'hz'||item === 'tcount'||item === 'mcn'){
        if(data[item]){
          query = query + '&' + item + '=' + 1
        }
      } else {
        if (data[item]) {
          query += '&' + item + '=' + data[item]
        }
      }
    }
    query = query.substring(1, query.length)
    console.log(query, 11111)
    return Axios({
      url: "ks-list?" + query,
      method: "get",
    });
  },
  getKsProfile(datas){
    // 达人基础数据
    return Axios({
      url: "ks-profile" + datas,
      method: "get",
      showLoading: false
    });
  },
  getKsPortrait(datas){
    // 达人画像分析
    return Axios({
      url: "ks-portrait" + datas,
      method: "get",
      showLoading: false
    });
  },
  getksIndex(datas){
    // 达人基础数据
    return Axios({
      url: "ks-index" + datas,
      method: "get",
      showLoading: false
    });
  },
  getWorksinfo(datas){
    // 达人作品
    return Axios({
      url: "ks-worksinfo" + datas,
      method: "get",
      showLoading: false
    });
  },
  getKsVideoplay(datas){
    // 发布频次分布
    return Axios({
      url: "ks-videoplay" + datas,
      method: "get",
      showLoading: false
    });
  },
  getKsCommerce(datas,param){
    // 达人带货数据
    return Axios({
      url: "ks-commerce" + datas+ "?" + param,
      method: "get",
    });
  },
  getKsFans(datas){
    // 达人粉丝分析
    return Axios({
      url: "ks-fans" + datas,
      method: "get",
      showLoading: false
    });
  },
  getKsCommerceInfo(datas){
    // 获得达人电商带货
    return Axios({
      url: "ks-commerce-info" + datas,
      method: "get",
      showLoading: false
    })
  },
  getKsWorkDetail(datas,params){
    // 单个达人作品详情
    return Axios({
      url: "ks-workdetail" + datas,
      method: "get",
      showLoading: false,
      params
    })
  }

}

const getData = {
  // 回款情况
  getReceivable(data, param) {
    return Axios({
      url: 'dr-repay' + data + '?' + param,
      method: 'get'
    })
  },
  // 历史合作情况图表数据
  getHistoryCoop(data, param) {
    return Axios({
      url: 'dr-cooper' + data + '?' + param,
      method: 'get'
    })
  },
  getDrList(datas,param) {
    //   获取合作案例
    return Axios({
      url: "dr-list" + datas + "?" + param,
      method: "get",
    });
  },
  getGameList(datas,param) {
    //   获取达人星图游戏
    return Axios({
      url: "game-list" + datas+ "?" + param,
      method: "get",
    });
  },
  getGameInfo(datas,param) {
    //   获取达人游戏数据
    return Axios({
      url: "game-info" + datas+ "?" + param,
      method: "get",
    });
  },

  getQueryInfo(param) {
    return Axios({
      url: "author-options"+ "?" + param,
      method: "get",
    });
  },
  // getTableInfo(data) {
  //   let query = ''
  //   for (let item in data) {
  //     if (item === 'tags' && data[item].length !== 0) {
  //       query = query + '&tag=' + data[item].join(',')
  //     } else if (data[item] && data[item].length !== 0) {
  //       if (item === 'tag' || item === 'industry_tag_level_one') {
  //         if (data[item] != 0) {
  //           query = query + '&' + item + '=' + data[item]
  //         }
  //       } else if (item === 'fans_increment_within_30d_is_positive' || item === 'settlement_type' || item === 'is_author_plan' || item === 'is_fan_incr_rapidly'|| item === 'is_superstar'|| item === 'e_commerce_enable' || item === 'hz'|| item === 'tcount'|| item === 'mcn') {
  //         query = query + '&' + item + '=' + '1'
  //       } else if (item === 'ages' || item === 'cities' || item === 'systems') {
  //         query = query + '&' + data[item].join('&')
  //       }else if (item === 'grenders') {
  //         query = query + '&' + data[item]
  //       } else if (item === 'watcher_ages' || item === 'watcher_cities' || item === 'watcher_systems') {
  //         query = query + '&' + data[item].join('&')
  //       }else if (item === 'watcher_grenders') {
  //         query = query + '&' + data[item]
  //       } else if (item === 'devidedrate_ge') {
  //         if(data[item]!=='0'){
  //           query = query + '&' + item + '=' + data[item]
  //         }
  //       } else if(item === 'tag_author_style'){
  //         if(data[item]!=='0'){
  //           query = query + '&' + item + '=' + data[item]
  //         }
  //       }else {
  //         query = query + '&' + item + '=' + data[item]
  //       }
  //     }
  //   }
  //   if (query.indexOf('&') === 0) {
  //     query = query.slice(1)
  //   }
  //   console.log(1111,query)
  //   return Axios({
  //     url: "author-list?" + query,
  //     method: "get",
  //   });
  // },
  getTableInfo(data) {
    let query = ''
    for (let item in data) {
      if (item === 'tags' && data[item].length !== 0) {
        query = query + '&tag=' + data[item].join(',')
      } else if (data[item] && data[item].length !== 0) {
        if (item === 'tag' || item === 'industry_tag_level_one') {
          if (data[item] != 0) {
            query = query + '&' + item + '=' + data[item]
          }
        } else if (item === 'fans_increment_within_30d_is_positive' || item === 'is_author_plan' || item === 'is_fan_incr_rapidly'|| item === 'is_superstar'|| item === 'e_commerce_enable' || item === 'hz'|| item === 'tcount'|| item === 'mcn'||item === 'has_coupon'||item === 'can_order_boost'||item === 'is_short_drama') {
          query = query + '&' + item + '=' + '1'
        } else if (item === 'settlement_type') {
          query = query + '&' + item + '=' + '14'
        }
        else if (item === 'ages' || item === 'cities' || item === 'systems') {
          query = query + '&' + data[item].join('&')
        }else if (item === 'grenders') {
          query = query + '&' + data[item]
        } else if (item === 'watcher_ages' || item === 'watcher_cities' || item === 'watcher_systems') {
          query = query + '&' + data[item].join('&')
        }else if (item === 'watcher_grenders') {
          query = query + '&' + data[item]
        } else if (item === 'devidedrate_ge') {
          if(data[item]!=='0'){
            query = query + '&' + item + '=' + data[item]
          }
        } else if(item === 'tag_author_style'){
          if(data[item]!=='0'){
            query = query + '&' + item + '=' + data[item]
          }
        }else {
          query = query + '&' + item + '=' + data[item]
        }
      }
    }
    if (query.indexOf('&') === 0) {
      query = query.slice(1)
    }
    return Axios({
      url: "author-livelist?" + query,
      method: "get",
    });
  },
  getDarenInfo(datas) {
    //   获取达人基础信息
    return Axios({
      url: "author-info" + datas,
      method: "get",
      showLoading: false
    });
  },
  getDarenDesc(datas) {
    //   获取达人介绍
    return Axios({
      url: "author-desc" + datas,
      method: "get",
      showLoading: false
    });
  },
  getDarenPrice(datas, showLoading = false) {
    //   获取达人报价信息
    return Axios({
      url: "author-price" + datas,
      method: "get",
      showLoading: false
    });
  },
  getDarenIndex(datas) {
    //   获取达人指数数据
    return Axios({
      url: "author-score" + datas,
      method: "get",
    });
  },
  getHotWord(datas, showLoading = false) {
    //   获取达人热评词
    return Axios({
      url: "author-comment" + datas,
      method: "get",
      showLoading: false
    });
  },
  getHotContent(datas, showLoading = false) {
    //   获取达人热评词
    return Axios({
      url: "author-content" + datas,
      method: "get",
      showLoading: false
    });
  },
  getHotWord2(datas) {
    //   获取达人热评词2
    return Axios({
      url: "author-stat" + datas,
      method: "get",
    });
  },
  getDarenItems(datas, showLoading = false) {
    //   获取达人播放数据
    return Axios({
      url: "author-items" + datas,
      method: "get",
      showLoading
    });
  },
  getDarenSpread(datas, param) {
    //   获取达人传播指数
    return Axios({
      url: "author-spread" + datas + "?" + param,
      method: "get",
      showLoading: false
    });
  },
  getDarenFans(datas, param) {
    //   获取达人粉丝数据
    return Axios({
      url: "author-fans" + datas + "?" + param,
      method: "get",
    });
  },
  getDarenGoods(datas, param) {
    //   获取达人带货列表
    return Axios({
      url: "author-ecomlist" + datas + "?" + param,
      method: "get",
    });
  },
  getDarenGoodsIndex(datas, param) {
    //   获取达人带货指数
    return Axios({
      url: "author-ecom" + datas + "?" + param,
      method: "get",
    });
  },
  getDarenCoope(datas) {
    //   获取达人任务数据
    return Axios({
      url: "author-coope" + datas,
      method: "get",
      showLoading: false
    });
  },
  getDarenCategory(datas) {
    //   获取达人带货品类
    return Axios({
      url: "author-category" + datas,
      method: "get",
    });
  },
  getDarenWfan(datas, showLoading = false) {
    //   获取达人观众分布数据
    return Axios({
      url: "link-distribution" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorCpinfo(datas) {
    //   性价比能力分析
    return Axios({
      url: "author-cpinfo" + datas,
      method: "get",
      showLoading: false
    });
  },
  getCoopDistribution(datas) {
    //   合作行业商单分析
    return Axios({
      url: "coop-distribution" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorTouchdist(datas, showLoading = false) {
    //   获得达人的连接用户来源
    return Axios({
      url: "author-touchdist" + datas,
      method: "get",
      showLoading
    });
  },
  getDailyFans(datas, showLoading = false) {
    //   获取账号粉丝趋势
    return Axios({
      url: "author-dailyfans" + datas,
      method: "get",
      showLoading
    });
  },
  getLinkDaily(datas, showLoading = false) {
    //   获取账号连接用户趋势
    return Axios({
      url: "link-daily" + datas,
      method: "get",
      showLoading
    });
  },
  getDarenFansdist(datas, showLoading = false) {
    //   获取达人粉丝分布数据
    return Axios({
      url: "author-fans-distribution" + datas,
      method: "get",
      showLoading
    });
  },
  getLinkStruct(datas, showLoading = false) {
    //   获取账号连接用户分布
    return Axios({
      url: "link-struct" + datas,
      method: "get",
      showLoading: false
    });
  },
  getLinkCard(datas, showLoading = false) {
    //   获得达人的连接用户分布30天环比
    return Axios({
      url: "link-card" + datas,
      method: "get",
      showLoading: false
    });
  },
  getLinkDistribution(datas) {
    //   获取账号连接用户画像
    return Axios({
      url: "link-distribution" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorVideodist(datas) {
    //   获得达人的内容类型分析
    return Axios({
      url: "author-videodist" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorConvertability(datas) {
    //   获取账号转化能力分析
    return Axios({
      url: "author-convertability" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorEcomvideo(datas) {
    //   获得转换视频
    return Axios({
      url: "author-ecomvideo" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorCategory(datas) {
    //   抖音小店带货排行
    return Axios({
      url: "author-category" + datas,
      method: "get",
    });
  },
  getLinkDailyScore(datas) {
    //   获取账号商业指数趋势
    return Axios({
      url: "link-daily-score" + datas,
      method: "get",
      showLoading: false
    });
  },
  getSameDarenRec(datas, showLoading = false) {
    //   获取相似达人推荐接口
    return Axios({
      url: "author-rec" + datas,
      method: "get",
      showLoading
    });
  },
  getSuccessExample(datas) {
    //   获取成功案例接口
    return Axios({
      url: "order-list" + datas,
      method: "get",
    });
  },
  getVideoData(data) {
    let query = ''
    for (let item in data) {
      query = query + '&' + item + '=' + data[item]
    }

    if (query.indexOf('&') === 0) {
      query = query.slice(1)
    }
    return Axios({
      url: "author-video?" + query,
      method: "get",
    });
  },
  getAuthorDrinfo(datas) {
    //   获取达人评价
    return Axios({
      url: "author-drinfo" + datas,
      method: "get",
    });
  },
  getAuthorSelf(datas) {
    //   获取站内达人信息
    return Axios({
      url: "author-self" + datas,
      method: "get",
    });
  },
  getLinkInfo(datas) {
    //   获取星图指数
    return Axios({
      url: "link-info" + datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorIndustry() {
    //   获取行业数据
    return Axios({
      url: "author-industry",
      method: "get",
      showLoading: false
    });
  },
  getAuthorVideoRec(datas) {
    //   获取内容表现视频
    return Axios({
      url: "author-video-rec"+datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorVideoInfo(datas){
    //获取星图视频ID数据
    return Axios({
      url: "ggeneric-vid"+datas,
      method: "get",
      showLoading: false
    });
  },
  checkControl(datas) {
    //   检查状态
    return Axios({
      url: "check-control"+datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorVideoSpread(datas) {
    //   获取优秀传播视频
    return Axios({
      url: "author-video-spread"+datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorVideoShop(datas) {
    //   获取种草指数视频
    return Axios({
      url: "author-video-shop"+datas,
      method: "get",
      showLoading: false
    });
  },
  getAuthorUri(datas) {
    //   获取种草指数视频
    return Axios({
      url: "author-uri"+datas,
      method: "get",
      showLoading: false
    });
  },
}


const login = {

  login(datas) {
    //   获取达人粉丝分布数据
    return Axios({
      url: "author-login",
      method: "post",
      data: datas
    });
  },
}

const helper = {
  getIndustry() {
    return Axios({
      url: "author-categorylist",
      method: "get",
    });
  },

  getData(data) {
    let query = ''
    for (let item in data) {
      if (data[item]) {
        query = query + '&' + item + '=' + data[item]
      }
    }
    if (query.indexOf('&') === 0) {
      query = query.slice(1)
    }
    return Axios({
      url: "author-recommend?" + query,
      method: "get",
    });
  }
}
const getCooperationDetailData = {
  getAuthorUri(datas) {
    //   获取合作案例(一口价短视频)
    return Axios({
      url: "author-uri" + datas,
      method: "get",
      showLoading: false
    });
  },
  getDrDetail(datas) {
    //   获取合作案例(一口价短视频)
    return Axios({
      url: "dr-detail" + datas,
      method: "get",
    });
  },
  getDrLive(datas) {
    //   获取合作案例(一口价直播)
    return Axios({
      url: "dr-live" + datas,
      method: "get",
    });
  },
  getDrCpm(datas) {
    //   获取合作案例(效果类)
    return Axios({
      url: "dr-cpm" + datas,
      method: "get",
    });
  },
}

const getDetailData = {
  getOrderOverview(datas) {
    //   获取订单投后分析报表
    return Axios({
      url: "order-overview" + datas,
      method: "get",
    });
  },
  getOrderUser(datas) {
    //   获取订单投后受众报表
    return Axios({
      url: "order-user" + datas,
      method: "get",
    });
  },
  getOrderBasic(datas) {
    //   获取订单指数详情
    return Axios({
      url: "order-basic" + datas,
      method: "get",
    });
  },
  getOrderConvert(datas) {
    //   获取订单转化详情
    return Axios({
      url: "order-convert" + datas,
      method: "get",
    });
  },
  getOrderStatics(datas,param) {
    //   获取订单传播表现详情
    return Axios({
      url: "order-statics" + datas+ "?" + param,
      method: "get",
    });
  },
  getOrderReal(datas,param) {
    //   获取实时数据
    return Axios({
      url: "order-real" + datas+ "?"+ param,
      method: "get",
    });
  },
  getOrderComponent(datas,param) {
    //   获取订单转化详情
    return Axios({
      url: "order-component" + datas+ "?" + param,
      method: "get",
    });
  },
  getOrderBase(datas) {
    //   获取订单指数
    return Axios({
      url: "order-base" + datas,
      method: "get",
    });
  },
  getOrderCreative(datas) {
    //   获取订单创意解析详情
    return Axios({
      url: "order-creative" + datas,
      method: "get",
    });
  },
  getOrderWatch(datas) {
    //   获取订单创意观看时长曲线
    return Axios({
      url: "order-watch" + datas,
      method: "get",
    });
  },
  getOrderDetail(datas) {
    //   获取订单详情
    return Axios({
      url: "order-detail" + datas,
      method: "get",
    });
  },
  getOrderDistri(datas,param) {
    //   获取订单用户画像
    return Axios({
      url: "order-distri" + datas+ "?" + param,
      method: "get",
    });
  },
  getAuthorVideo(datas) {
    //   获取视频达人评价
    return Axios({
      url: "author-video" + datas,
      method: "get",
    });
  }

}

const same = {
  getAuthorList(param) {
    return Axios({
      url: "author-list"+ "?" + param,
      method: "get",
    })
  },
  getAuthorRec(data,param) {
    return Axios({
      url: "author-rec"+data+ "?" +"only_nick_name=1&"+ param,
      method: "get",
    })
  },
}

const orderRecommend = {
  getXdOption() {
    return Axios({
      url: "xd-option",
      method: "get",
    })
  },
  getXdList(param) {
    return Axios({
      url: "xd" + "?" + param,
      method: "get",
    })
  },
}

const ksHelper = {
  getksIndustry(param) {
    return Axios({
      url: "ks-industry" + "?" + param,
      method: "get",
    })
  },
  getKsReco(param) {
    return Axios({
      url: "ks-reco?" + param,
      method: "get",
    })
  },
}

// 观星数据统计埋点
const setUseLog = function(params) {
  Axios.post(`/api.php?m=log|api|gx&a=log`, params, {headers: { showLoading: false, hideTip: true }}).then(res => {
  })
}

const setUserTimeLog = async function() {
  const { data } = await Axios({
    url: "author-check",
    method: "get",
    showLoading: false
  });
  if (data.code !== 0 && process.env.NODE_ENV !== "development") {
    await logout()
  }
}

export async function logout() {
    await Axios({
      url: "author-logout",
      method: "get",
      showLoading: false
    });
    // console.log('登出',data);
    localStorage.setItem('api_token', '')
    localStorage.setItem('deviceid', '')
    localStorage.setItem('uid', '')
    localStorage.setItem('name', '')
    localStorage.setItem('inSalesGroup', '')
    sessionStorage.setItem('uid', '')
    sessionStorage.setItem('name', '')
    sessionStorage.setItem('inSalesGroup', '')
    localStorage.setItem('gx_centername', '')
    localStorage.setItem('auth', JSON.stringify({}))
    localStorage.setItem('scheduleAuth', JSON.stringify({}))
    store.commit('AUTH', JSON.stringify({}))
    VueCookies.set("authsign",'' ,'1m', null, "changwankeji.com");
    router.push({ name: 'Login' })
}

export default {
  same,
  getData,
  login,
  logout,
  helper,
  getDetailData,
  getCooperationDetailData,
  getKuaishouData,
  orderRecommend,
  ksHelper,
  getBZhanData,
  setUseLog,
  setUserTimeLog
}